import { PartialWithId } from '@inmagik/react-crud/dist/types'
import { Formik } from 'formik'
import { Button, Modal } from 'react-bootstrap'
import MaterialIcon from './MaterialIcon'

interface ModalFormProps<T> {
  isOpen: boolean
  toggle: () => void
  title?: string
  initialValues: PartialWithId<T>
  schema: any
  save: (record: PartialWithId<T>, actions: any) => Promise<any>
  children?: React.ReactNode
  labelSave?: string
  size?: 'sm' | 'lg' | 'xl'
  showSave?: boolean
  buttonExtraAction?: any
  context?: any
}

export default function ModalForm<T>({
  isOpen,
  toggle,
  title,
  initialValues,
  schema,
  save,
  children,
  labelSave,
  size = 'lg',
  showSave = true,
  buttonExtraAction,
}: ModalFormProps<T>) {
  return (
    <Formik initialValues={initialValues} onSubmit={save} validationSchema={schema} enableReinitialize>
      {({ handleSubmit, isSubmitting }) => (
        <Modal show={isOpen} onHide={toggle} centered contentClassName="bg-topbar" size={size}>
          <form>
            <Modal.Header>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: 'calc(100vh - 200px)',
                overflowY: 'auto',
              }}
            >
              {children}
            </Modal.Body>

            <Modal.Footer>
              <div className="w-100 d-flex align-items-center justify-content-end">
                <Button type="button" onClick={toggle} variant="outline-secondary" className="me-2">
                  Chiudi
                </Button>
                {buttonExtraAction && !showSave && (
                  <Button
                    type="button"
                    onClick={buttonExtraAction}
                    variant="secondary"
                    className="me-2 text-white d-flex align-items-center"
                  >
                    <MaterialIcon icon="save" className="me-2" />
                    {labelSave || 'Salva'}
                  </Button>
                )}
                {showSave && (
                  <Button
                    onClick={() => {
                      handleSubmit()
                    }}
                    disabled={isSubmitting}
                    variant="secondary"
                    className="text-white d-flex align-items-center"
                  >
                    <MaterialIcon icon="save" className="me-2" />
                    {labelSave || 'Salva'}
                  </Button>
                )}
              </div>
            </Modal.Footer>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
